import { format } from "date-fns";

import { Button } from "@/components/ui";
import type { UserSubscription } from "@/services/api-client/subscriptions/types";
import { formatCurrency } from "@/utils/currency";

import { SubscriptionDetailRow } from "./SubscriptionDetailRow";

const formatDate = (iso: string) => format(new Date(iso), "dd/MM/yyyy");

interface SubscriptionCardProps {
  subscription: UserSubscription;
  onCancel: () => void;
  isCancelling: boolean;
}

export const SubscriptionCard = ({
  subscription,
  onCancel,
  isCancelling,
}: SubscriptionCardProps) => {
  return (
    <div className="rounded-2xl bg-card p-6">
      <h2 className="text-center font-semibold text-xl text-zinc-900">Subscription</h2>

      <dl className="mt-6 space-y-4 text-zinc-700">
        <SubscriptionDetailRow
          label="Billing period:"
          value={`${subscription.plan.duration_in_days}-days`}
        />
        {subscription.next_billing_date && (
          <SubscriptionDetailRow
            label="Next payment date:"
            value={formatDate(subscription.next_billing_date)}
          />
        )}
        <SubscriptionDetailRow
          label="Subscription price:"
          value={formatCurrency(subscription.plan.price, subscription.plan.currency)}
        />
        <SubscriptionDetailRow
          label="Subscription total:"
          value={formatCurrency(subscription.plan.price, subscription.plan.currency)}
        />
        <SubscriptionDetailRow
          label="Expires on:"
          value={formatDate(subscription.end_date)}
        />
      </dl>

      <Button
        className="mt-6 w-full"
        onClick={onCancel}
        disabled={isCancelling || subscription.status !== "Active"}
      >
        Cancel Subscription
      </Button>
    </div>
  );
};
